export default "__VITE_ASSET__CGM5jMNt__"